module.exports = __webpack_public_path__ + "fonts/vector_3.svg";